import React from 'react'
import styled from 'styled-components'

import { WidgetLayout } from '../widget-layout'

const Header = styled.div`
    width: 30%;
    height: 30px;
    border-radius: 8px;
`

const Content = styled.div<{ height?: string }>`
    height: ${({ height }) => height ?? '100px'};
    border-radius: 8px;
`

const Button = styled.div`
    width: 130px;
    height: 40px;
    border-radius: 16px;
    &.sm {
        height: 30px;
    }
`

export type WidgetLoadingStateProps = {
    title?: string
    headerButton?: boolean
    button?: boolean
    buttonLeftPosition?: boolean
    height?: string
}

export const WidgetLoadingState = React.memo(function WidgetLoadingState({
    title,
    headerButton,
    height,
}: WidgetLoadingStateProps): React.ReactElement {
    return (
        <WidgetLayout
            data-testid="widgetLoadingState"
            title={title ? title : <Header className="shimmer-container" />}
            actionButtons={<Button className="shimmer-container" />}
            {...(headerButton && { headerButtons: <Button className="shimmer-container sm" /> })}
        >
            <Content className="shimmer-container" height={height}></Content>
        </WidgetLayout>
    )
})
